module.exports = __webpack_public_path__ + "img/LEAF-T.3535e598.svg";